import { App } from 'antd';
import { useDeleteLanguage } from '@/hooks/useLanguages';
import type { Language } from '@/types/language';

export function useConfirmDeleteLanguage() {
  const { message, modal } = App.useApp();
  const mutation = useDeleteLanguage();
  return (language: Language) =>
    new Promise<boolean>((resolve) => {
      if (language.is_bundled) {
        message.error('Bundled languages cannot be deleted');
        resolve(false);
        return;
      }
      modal.confirm({
        title: `Delete language ${language.code}?`,
        content: `This removes the language entry and all ${language.code} translations.`,
        okText: 'Delete',
        okButtonProps: { danger: true },
        onOk: async () => {
          try {
            await mutation.mutateAsync(language.code);
            message.success(`${language.code} deleted`);
            resolve(true);
          } catch (e) {
            message.error((e as Error).message);
            resolve(false);
          }
        },
        onCancel: () => resolve(false),
      });
    });
}
